import { create } from "zustand";

import { getWorkspaceSettings, getWorkspaceSettingsStudent } from "../api/workspaceSettings";
import { WorkspaceSettingsResponse } from "../types/workspaceSettings";

import useUserStore from "@/features/auth/store/useUserStore";

interface WorkspaceSettingsState {
  settings: WorkspaceSettingsResponse | null;
  isLoading: boolean;
  error: string | null;
  setSettings: (settings: WorkspaceSettingsResponse) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
  refetch: (workspaceId: string) => Promise<void>;
}

export const useWorkspaceSettingsStore = create<WorkspaceSettingsState>((set, get) => ({
  settings: null,
  isLoading: false,
  error: null,
  setSettings: (settings) => set({ settings, error: null }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error, isLoading: false }),
  reset: () => set({ settings: null, isLoading: false, error: null }),
  refetch: async (workspaceId: string) => {
    const { setSettings, setLoading, setError } = get();
    const { user } = useUserStore.getState();
    const isStudent = user?.role === "student";

    setLoading(true);
    try {
      const response = isStudent
        ? await getWorkspaceSettingsStudent(workspaceId)
        : await getWorkspaceSettings(workspaceId);

      setSettings(response.data.data);
    } catch (error) {
      console.error("Failed to refetch workspace settings:", error);
      setError("Failed to refresh workspace settings");
    } finally {
      setLoading(false);
    }
  },
}));
